import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import httpClient from "../../custom-hooks/httpClient";
import { isCommissionWallet } from "../Transfers/OtherWallet/InitiateTransfer";

// Savings wallet is not transactable. Its own dedicated transaction history in the Savings dashboard.
const isTransactableWallet = (wallet) =>
  !isCommissionWallet(wallet.product_id) && wallet.type !== "savings";

function TransactionHistory({ wallets }) {
  const transactableWallets = wallets.filter(isTransactableWallet);

  const [walletNumber, setWalletNumber] = useState(
    transactableWallets[0]?.account_no,
  );
  const [type, setType] = useState("mini");
  const [transactions, setTransactions] = useState([]);

  const changeWallet = (e) => setWalletNumber(e.target.value);
  const changeType = (e) => setType(e.target.value);

  useEffect(() => {
    if (walletNumber) {
      httpClient
        .get(`/transactions?wallet_account_number=${walletNumber}&type=${type}`)
        .then(({ status, data }) => {
          if (status === 200) {
            setTransactions(data.transactionHistory);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(
            err.response.data.message || "Error getting transaction history"
          );
        });
    } else return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletNumber]);

  function switchTransType(type) {
    if (type.toLowerCase() === "intra-inward") {
      return "Kegow Transfer (Credit)";
    } else if (type.toLowerCase() === "intra-outward") {
      return "Kegow Transfer (Debit)";
    } else if (type.toLowerCase() === "inter-outward") {
      return "Bank Transfer (Debit)";
    } else if (type.toLowerCase() === "inter-inward") {
      return "Bank Transfer (Credit)";
    } else {
      return type;
    }
  }

  return (
    <div className="row">
      <div className="col-xl-12 col-md-12 mb-12">
        <div className="card border-left-primary shadow h-100 py-2">
          <div className="card-header py-3">
            <h1 className="h3 mb-0 text-gray-800">Transaction History</h1>
            <div className="d-flex justify-content-between py-3">
              <select className="form-select" onChange={changeWallet}>
                {transactableWallets.map((w) => (
                  <option value={w.account_no} key={w.id}>
                    {!isCommissionWallet(w.product_id) && `${w.account_no} | `}
                    {w.name}
                  </option>
                ))}
              </select>
              <select className="form-select" onChange={changeType}>
                <option value="mini">Mini statement</option>
                {/* <option value="full">Full statement</option> */}
              </select>
            </div>
          </div>
          <div className="card-body">
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Narration</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((t, i) => (
                  <tr key={i}>
                    <td>
                      {new Date(t.transaction_date).toLocaleDateString(
                        undefined,
                        { year: "numeric", month: "long", day: "numeric" }
                      )}
                    </td>
                    <td>{switchTransType(t.transaction_type)}</td>
                    <td
                      className={`${
                        t.transaction_type === "Credit" ||
                        t.transaction_type === "inter-inward" ||
                        t.transaction_type === "intra-inward"
                          ? "text-primary"
                          : "text-danger"
                      }`}
                    >
                      &#8358;{Number(t.amount).toFixed(2)}
                    </td>
                    <td>{t.narration}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionHistory;
